/**
 * Model note over the product photo ("MODEL IS 167CM WEARING SIZE XS REGULAR").
 *
 * The sentence itself is content: each product template carries its own text
 * block ("The model is 167cm and wears size XS in regular"), which is what the
 * merchant edits in the theme editor. Rather than keeping a second copy in a
 * setting that would drift from it, the note is read off the page and shortened
 * to the form the badge wants, so every product gets its own figures with
 * nothing to maintain twice.
 */
(function () {
  var NOTE_CLASS = 'kalea-model-note';

  /**
   * Colours photographed on a different size than the template's sentence
   * states. The pants were shot in S for black and in XS for every other
   * colour, and the gallery swaps with the swatch, so the note has to follow.
   * Keyed by product handle, then by the colour exactly as the swatch names it.
   */
  var SIZE_BY_COLOR = {
    'wide-leg-activewear-pants-women-kalea': { Black: 'S' },
    'leasilk-wide-leg-pants-tall': { Black: 'S' },
  };

  function handleFor(root) {
    // The sheet shows a product the page it sits on is not, so its own title
    // link is the only honest source of the handle there.
    var link = root.querySelector('.product-header a[href*="/products/"]');
    var path = link ? link.getAttribute('href') : window.location.pathname;

    var handle = decodeURIComponent(path).split('/products/')[1];
    return handle ? handle.split(/[?#]/)[0] : null;
  }

  function sizeOverride(root) {
    var handle = handleFor(root);
    var byColor = handle ? SIZE_BY_COLOR[handle] : null;
    if (!byColor) return null;

    var swatch = root.querySelector('variant-picker input[name^="Color-"]:checked');
    return swatch ? byColor[swatch.value.trim()] || null : null;
  }

  function withSize(sentence, size) {
    return size ? sentence.replace(/(wears size |wearing size )(\S+)/i, '$1' + size) : sentence;
  }

  /**
   * The sentence itself is rewritten too, so the line above Add to cart agrees
   * with the badge on the photo. The template's wording is kept on the element
   * the first time round: without it, switching from a colour that overrides
   * the size to one that does not would leave the override behind.
   */
  function applySentence(root) {
    var size = sizeOverride(root);

    var selector = '[data-kalea-model-base], .product-details p, .product-details li, .quick-add-model-note';

    root.querySelectorAll(selector).forEach(function (element) {
      var base = element.getAttribute('data-kalea-model-base');
      if (!base) {
        var text = (element.textContent || '').trim();
        if (!/^the model is\b/i.test(text) || element.children.length) return;
        base = text;
        element.setAttribute('data-kalea-model-base', base);
      }

      var next = withSize(base, size);
      if (element.textContent !== next) element.textContent = next;
    });
  }

  /** "The model is 167cm and wears size XS in regular" -> "Model is 167cm wearing size XS regular" */
  function shorten(sentence) {
    var text = sentence
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/^the\s+/i, '')
      .replace(/\s+and\s+wears\s+size\s+/i, ' wearing size ')
      // "in regular" / "in tall" reads as filler once the sentence is this short.
      .replace(/\s+in\s+(regular|tall)\b/i, ' $1')
      .replace(/[.\s]+$/, '');

    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function findSentence(root) {
    var candidates = root.querySelectorAll('.product-details p, .product-details li');

    for (var i = 0; i < candidates.length; i++) {
      var element = candidates[i];
      var base = element.getAttribute('data-kalea-model-base');
      var text = base || (element.textContent || '').trim();
      if (/^the model is\b/i.test(text)) return text;
    }

    return null;
  }

  function render() {
    var sheet = document.getElementById('quick-add-modal-content');
    if (sheet) applySentence(sheet);

    var grid = document.querySelector('[data-product-grid-content]');
    if (!grid) return;

    applySentence(grid);

    // position: relative already, and it is the frame the slides move inside,
    // so the note stays put while the gallery is paged.
    var frame = grid.querySelector('media-gallery slideshow-component') || grid.querySelector('media-gallery');
    if (!frame) return;

    var sentence = findSentence(grid);
    var existing = frame.querySelector(':scope > .' + NOTE_CLASS);

    if (!sentence) {
      if (existing) existing.remove();
      return;
    }

    var text = withSize(shorten(sentence), sizeOverride(grid));

    var note = existing || document.createElement('div');
    note.className = NOTE_CLASS;
    // Decorative duplicate of text that is already on the page in full.
    note.setAttribute('aria-hidden', 'true');
    note.textContent = text;
    if (!existing) frame.appendChild(note);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // The Length switch swaps the whole product grid in place, and the gallery
  // re-renders on variant changes, so the note is put back whenever the page
  // rebuilds rather than only once at load.
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      render();
    }, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
